import { ArAgingBucket } from "@common/types/reports/ar-aging";
import { PreviewArAgingSummaryDataset } from "../previewTypes";

export const AR_AGING_SUMMARY_DATASET: PreviewArAgingSummaryDataset = {
    shape: "ar-aging-summary",
    customerHeader: "Customer",
    totalHeader: "Total",
    percentHeader: "% of total",
    percentBase: 1087972,
    rows: [
        {
            id: "acme-corp",
            label: "Acme Corp",
            kind: "line",
            buckets: {
                [ArAgingBucket.CURRENT]: 412500,
                [ArAgingBucket.DAYS_1_TO_30]: 28350.5,
                [ArAgingBucket.DAYS_31_TO_60]: 3200,
                [ArAgingBucket.DAYS_61_TO_90]: 0,
                [ArAgingBucket.DAYS_91_AND_OVER]: 0,
            },
            total: 444050.5,
        },
        {
            id: "globex",
            label: "Globex",
            kind: "line",
            buckets: {
                [ArAgingBucket.CURRENT]: 285000,
                [ArAgingBucket.DAYS_1_TO_30]: 41200,
                [ArAgingBucket.DAYS_31_TO_60]: 0,
                [ArAgingBucket.DAYS_61_TO_90]: 2750.25,
                [ArAgingBucket.DAYS_91_AND_OVER]: 0,
            },
            total: 328950.25,
        },
        {
            id: "hooli",
            label: "Hooli",
            kind: "line",
            buckets: {
                [ArAgingBucket.CURRENT]: -18400,
                [ArAgingBucket.DAYS_1_TO_30]: 0,
                [ArAgingBucket.DAYS_31_TO_60]: 0,
                [ArAgingBucket.DAYS_61_TO_90]: 0,
                [ArAgingBucket.DAYS_91_AND_OVER]: 0,
            },
            total: -18400,
        },
        {
            id: "initech",
            label: "Initech",
            kind: "line",
            buckets: {
                [ArAgingBucket.CURRENT]: 96750.75,
                [ArAgingBucket.DAYS_1_TO_30]: 12480,
                [ArAgingBucket.DAYS_31_TO_60]: 0,
                [ArAgingBucket.DAYS_61_TO_90]: 0,
                [ArAgingBucket.DAYS_91_AND_OVER]: 4125,
            },
            total: 113355.75,
        },
        {
            id: "northwind-co",
            label: "Northwind Co",
            kind: "line",
            buckets: {
                [ArAgingBucket.CURRENT]: 134200,
                [ArAgingBucket.DAYS_1_TO_30]: 0,
                [ArAgingBucket.DAYS_31_TO_60]: 5600,
                [ArAgingBucket.DAYS_61_TO_90]: 0,
                [ArAgingBucket.DAYS_91_AND_OVER]: 0,
            },
            total: 139800,
        },
        {
            id: "stark-labs",
            label: "Stark Labs",
            kind: "line",
            buckets: {
                [ArAgingBucket.CURRENT]: 61300,
                [ArAgingBucket.DAYS_1_TO_30]: 9875,
                [ArAgingBucket.DAYS_31_TO_60]: 0,
                [ArAgingBucket.DAYS_61_TO_90]: 0,
                [ArAgingBucket.DAYS_91_AND_OVER]: 640.5,
            },
            total: 71815.5,
        },
        {
            id: "umbrella",
            label: "Umbrella",
            kind: "line",
            buckets: {
                [ArAgingBucket.CURRENT]: 0,
                [ArAgingBucket.DAYS_1_TO_30]: 6420,
                [ArAgingBucket.DAYS_31_TO_60]: 0,
                [ArAgingBucket.DAYS_61_TO_90]: 1980,
                [ArAgingBucket.DAYS_91_AND_OVER]: 0,
            },
            total: 8400,
        },
        {
            id: "total",
            label: "Total",
            kind: "total",
            buckets: {
                [ArAgingBucket.CURRENT]: 971350.75,
                [ArAgingBucket.DAYS_1_TO_30]: 98325.5,
                [ArAgingBucket.DAYS_31_TO_60]: 8800,
                [ArAgingBucket.DAYS_61_TO_90]: 4730.25,
                [ArAgingBucket.DAYS_91_AND_OVER]: 4765.5,
            },
            total: 1087972,
            hasTopBorder: true,
        },
    ],
};
